import React, { CSSProperties, useMemo } from 'react';

interface IProps
{
	children?: React.ReactNode | React.ReactNode,
	onClick: () => void,
	className?: string,
	style?: CSSProperties,
	active?: boolean
}

export function SimpleIconButton(props: IProps)
{
	const className = useMemo(() =>
	{
		let cn = "icon-button icon-button--simple";
		if (props.className) {
			cn += ' ' + props.className;
		}
		if (props.active) {
			cn += " active";
		}

		return cn;
	}, [props.className, props.active]);

	return (
		<button className={className} style={props.style} onClick={props.onClick}>
			{props.children}
		</button>
	);
};